// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';

function EventNotes(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		eventNotesContainer: {
			marginBottom: '2em',
		},
		eventNotesDefault: {
			margin: '0 0 0.3em',
			whiteSpace: 'pre-wrap',
			wordBreak: 'keep-all',
		},
		eventNotesLabel: {
			display: 'block',
			fontWeight: '600',
			lineHeight: context.themeManager
				.value('event-description', 'lineHeight', 'line-height-300'),
		},
	};

	return (
		!props.eventNotes ? null :
		<div style={style.eventNotesContainer}>
			<p style={style.eventNotesLabel}>Hinweise zur Veranstaltung:</p>
			<div className="event__notes" style={style.eventNotesDefault}>
				{props.eventNotes}
			</div>
		</div>
	);
}

export default radium(EventNotes);
